import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const useTelegramStartParamRedirect = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const tg = window?.Telegram?.WebApp
    const startParam = tg?.initDataUnsafe?.start_param
    const hasBottleParam = startParam?.includes('bottle')

    if (hasBottleParam && location.state?.from === undefined) {
      const bottleId = startParam?.split('_')[1]

      if (bottleId) {
        localStorage.removeItem('redirectByLink')
        navigate(`/bottles/${bottleId}`, { replace: true })
      }
    }
  }, [navigate, location.state])
}
